import * as actions from '../actions/ramen-regions';
import * as models from '../../domain/models';
import cloneDeep from 'lodash/cloneDeep';

export interface State {
  isLoading: boolean;
  isLoaded: boolean;
  items: Array<models.RmnRegion>;
}

const initialState: State = {
  isLoading: false,
  isLoaded: false,
  items: null,
};

export function reducer(state = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.LOAD: {
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
      };
    }

    case actions.LOAD_SUCCESS: {
      const items = cloneDeep(action.payload.entities);
      return {
        ...state,
        items,
        isLoaded: true,
        isLoading: false,
      };
    }

    case actions.LOAD_FAIL: {
      return {
        ...state,
        isLoaded: true,
        isLoading: true,
      };
    }

    default: {
      return state;
    }
  }
}

export const getIsLoaded = (state: State) => state.isLoaded;
export const getIsLoading = (state: State) => state.isLoading;
export const getItems = (state: State) => state.items;
